import type { SummarizeStore } from './interfaces'

import { createInitialState } from './state'

const resetLessonData = (store: SummarizeStore): void => {
  store.bookingId = null
  store.summaryId = null
  store.duration = null
  store.speakingTime = null
  store.lessonDate = null
  store.summary = null
  store.recordingUrl = null
  store.topic = null
  store.highlights = []
  store.homeActivities = []
  store.homeTasks = []
  store.seekTime = null
}

export const actions = {
  resetState (this: SummarizeStore): void {
    Object.assign(this, createInitialState())
  },
  setBookingId (this: SummarizeStore, payload: SummarizeStore['bookingId']): void {
    this.bookingId = payload
  },
  setSummaryId (this: SummarizeStore, payload: SummarizeStore['summaryId']): void {
    this.summaryId = payload
  },
  setDuration (this: SummarizeStore, payload: SummarizeStore['duration']): void {
    this.duration = payload
  },
  setSpeakingTime (this: SummarizeStore, payload: SummarizeStore['speakingTime']): void {
    this.speakingTime = payload
  },
  setLessonDate (this: SummarizeStore, payload: SummarizeStore['lessonDate']): void {
    this.lessonDate = payload
  },
  setSummary (this: SummarizeStore, payload: SummarizeStore['summary']): void {
    this.summary = payload
  },
  setRecordingUrl (this: SummarizeStore, payload: SummarizeStore['recordingUrl']): void {
    this.recordingUrl = payload
  },
  setTopic (this: SummarizeStore, payload: SummarizeStore['topic']): void {
    this.topic = payload
  },
  setHighlights (this: SummarizeStore, payload: SummarizeStore['highlights']): void {
    this.highlights = payload
  },
  setHomeActivities (this: SummarizeStore, payload: SummarizeStore['homeActivities']): void {
    this.homeActivities = payload
  },
  setHomeTasks (this: SummarizeStore, payload: SummarizeStore['homeTasks']): void {
    this.homeTasks = payload
  },
  setRating (this: SummarizeStore, payload: SummarizeStore['rating']): void {
    this.rating = payload
  },
  setComment (this: SummarizeStore, payload: SummarizeStore['comment']): void {
    this.comment = payload
  },
  setSurvey (this: SummarizeStore, payload: SummarizeStore['survey']): void {
    this.survey = payload
  },
  setTitle (this: SummarizeStore, payload: SummarizeStore['title']): void {
    this.title = payload
  },
  setShow (this: SummarizeStore, payload: SummarizeStore['show']): void {
    this.show = payload
  },
  setBannerFeedback (this: SummarizeStore, payload: SummarizeStore['bannerFeedback']): void {
    this.bannerFeedback = payload
  },
  setSeekTime (this: SummarizeStore, payload: SummarizeStore['seekTime']): void {
    this.seekTime = payload
  },
  resetSummarizeData (this: SummarizeStore): void {
    this.show = false
    resetLessonData(this)
  },
  begin (this: SummarizeStore, id: number): number {
    if (id !== this.activeId) {
      resetLessonData(this)
      this.title = null
      this.survey = false
      this.rating = null
      this.comment = null
      this.activeId = id
    }

    this.requestId += 1
    this.status = 'loading'

    return this.requestId
  },
  settle (this: SummarizeStore, id: number, requestId: number): void {
    if (id !== this.activeId || requestId !== this.requestId) return

    this.status = 'ready'
  },
  fail (this: SummarizeStore, id: number, requestId: number): void {
    if (id !== this.activeId || requestId !== this.requestId) return

    this.status = 'error'
  },
}
